import React from "react";
import SlabCalculator from "../../components/User/Calculator/SlabCalculator";
import ColumnCalculator from "../../components/User/Calculator/ColumnCalculator";
import CircularSlabCalculator from "../../components/User/Calculator/CircularSlabCalculator";
import GutterCalculator from "../../components/User/Calculator/GutterCalculator";
import StairCalculator from "../../components/User/Calculator/StairCalculator";
import EstimateCalculator from "../../components/User/Calculator/EstimateCalculator";

const ConcreteCalculator = () => {
  return (
    <div className="w-full bg-white px-4 md:px-8 lg:px-10 py-16">
      {/* Header */}
      <div className="text-center mb-14">
        <span
          className="text-xs font-medium tracking-widest uppercase"
          style={{ color: "#c020d0", letterSpacing: "0.2em" }}
        >
          [OUR CALCULATOR]
        </span>

        <h1 className="text-3xl md:text-4xl lg:text-5xl text-[#041122] font-heading font-semibold mt-4">
          Explore Our Concrete Calculator
        </h1>
      </div>

      {/* Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_0.6fr] gap-10 w-full">
        {/* LEFT SIDE (scrolls normally) */}
        <div className="flex flex-col gap-8 w-full">
          <h2 className="text-3xl text-center font-heading font-semibold">
            Quantity Calculator
          </h2>

          <SlabCalculator />
          <ColumnCalculator />
          <CircularSlabCalculator />
          <GutterCalculator />
          <StairCalculator />
        </div>

        {/* RIGHT SIDE (sticky) */}
        <div className="w-full">
          <div className="sticky top-16">
            {" "}
            <h2 className="text-3xl text-center font-heading font-semibold mb-6">
              Estimate Calculator
            </h2>
            <EstimateCalculator />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConcreteCalculator;
